import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Material, Product, Store } from '../models/models-vm';
import { ErrorLoggerService } from '../../shared/services/error-logger.service';
import { MessageService } from '../../project-intake/services/message.service';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  private usaStates = [
    { id: 1, stateName: 'Alaska', stateCode: 'AK' },
    { id: 2, stateName: 'Alabama', stateCode: 'AL' },
    { id: 3, stateName: 'Arkansas', stateCode: 'AR' },
    { id: 4, stateName: 'Arizona', stateCode: 'AZ' },
    { id: 5, stateName: 'California', stateCode: 'CA' },
    { id: 6, stateName: 'Colorado', stateCode: 'CO' },
    { id: 7, stateName: 'Connecticut', stateCode: 'CT' },
    { id: 8, stateName: 'District of Columbia', stateCode: 'DC' },
    { id: 9, stateName: 'Delaware', stateCode: 'DE' },
    { id: 10, stateName: 'Florida', stateCode: 'FL' },
    { id: 11, stateName: 'Georgia', stateCode: 'GA' },
    { id: 12, stateName: 'Hawaii', stateCode: 'HI' },
    { id: 13, stateName: 'Iowa', stateCode: 'IA' },
    { id: 14, stateName: 'Idaho', stateCode: 'ID' },
    { id: 15, stateName: 'Illinois', stateCode: 'IL' },
    { id: 16, stateName: 'Indiana', stateCode: 'IN' },
    { id: 17, stateName: 'Kansas', stateCode: 'KS' },
    { id: 18, stateName: 'Kentucky', stateCode: 'KY' },
    { id: 19, stateName: 'Louisiana', stateCode: 'LA' },
    { id: 20, stateName: 'Massachusetts', stateCode: 'MA' },
    { id: 21, stateName: 'Maryland', stateCode: 'MD' },
    { id: 22, stateName: 'Maine', stateCode: 'ME' },
    { id: 23, stateName: 'Michigan', stateCode: 'MI' },
    { id: 24, stateName: 'Minnesota', stateCode: 'MN' },
    { id: 25, stateName: 'Missouri', stateCode: 'MO' },
    { id: 26, stateName: 'Mississippi', stateCode: 'MS' },
    { id: 27, stateName: 'Montana', stateCode: 'MT' },
    { id: 28, stateName: 'North Carolina', stateCode: 'NC' },
    { id: 29, stateName: 'North Dakota', stateCode: 'ND' },
    { id: 30, stateName: 'Nebraska', stateCode: 'NE' },
    { id: 31, stateName: 'New Hampshire', stateCode: 'NH' },
    { id: 32, stateName: 'New Jersey', stateCode: 'NJ' },
    { id: 33, stateName: 'New Mexico', stateCode: 'NM' },
    { id: 34, stateName: 'Nevada', stateCode: 'NV' },
    { id: 35, stateName: 'New York', stateCode: 'NY' },
    { id: 36, stateName: 'Ohio', stateCode: 'OH' },
    { id: 37, stateName: 'Oklahoma', stateCode: 'OK' },
    { id: 38, stateName: 'Oregon', stateCode: 'OR' },
    { id: 39, stateName: 'Pennsylvania', stateCode: 'PA' },
    { id: 40, stateName: 'Puerto Rico', stateCode: 'PR' },
    { id: 41, stateName: 'Rhode Island', stateCode: 'RI' },
    { id: 42, stateName: 'South Carolina', stateCode: 'SC' },
    { id: 43, stateName: 'South Dakota', stateCode: 'SD' },
    { id: 44, stateName: 'Tennessee', stateCode: 'TN' },
    { id: 45, stateName: 'Texas', stateCode: 'TX' },
    { id: 46, stateName: 'Utah', stateCode: 'UT' },
    { id: 47, stateName: 'Virginia', stateCode: 'VA' },
    { id: 48, stateName: 'Vermont', stateCode: 'VT' },
    { id: 49, stateName: 'Washington', stateCode: 'WA' },
    { id: 50, stateName: 'Wisconsin', stateCode: 'WI' },
    { id: 51, stateName: 'West Virginia', stateCode: 'WV' },
    { id: 52, stateName: 'Wyoming', stateCode: 'WY' }
  ];

  constructor(private httpClient: HttpClient,
    private msgService: MessageService,
    private errorLogService: ErrorLoggerService,) { }

  getAllCategories(vendorId: number): Observable<any> {
    const url = `${environment.gateway_url}/getallcategorysbyvendor/${vendorId}`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }


  getAllProducts(): Observable<any> {
    const url = `${environment.gateway_url}/getallproducts`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  getProductsByCategory(categoryId: number, isActive?: number,
    isVerified?: number
  ): Observable<any> {
    const active = isActive;
    const verified = isVerified;
    const url = `${environment.gateway_url}/getallproductsbycategory/${categoryId}/${active}/${verified}`; return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  addProduct(product: Product): Observable<number> {
    const url = `${environment.gateway_url}/saveupdateproduct`;
    return this.httpClient.post<number>(url, product)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  updateProduct(product: Product): Observable<number> {
    const url = `${environment.gateway_url}/saveupdateproduct`;
    return this.httpClient.post<number>(url, product)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  getAllStoresByVendor(vendorId: number, isActive?: number): Observable<any> {
    const active = isActive;
    const url = `${environment.gateway_url}/getallstoresbyvendor/${vendorId}/${active}`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  getAllVendors(): Observable<any> {
    const url = `${environment.gateway_url}/vendor`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  getUSStates(): Observable<{ stateName: string, stateCode: string }[]> {
    return of(this.usaStates);
  }

  getStatesByCountry(countryName: string): Observable<{ stateName: string; stateCode: string }[]> {
    const url = `${environment.gateway_url}/getstatedetails/${countryName}`;
    return this.httpClient.get<{ stateName: string; stateCode: string }[]>(url).pipe(
      catchError((error: HttpErrorResponse) => this.handleError1(error))
    );
  }

  updateStore(store: Store): Observable<number> {
    const url = `${environment.gateway_url}/saveupdatestore`;
    return this.httpClient.post<number>(url, store)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  addStore(store: Store): Observable<number> {
    const url = `${environment.gateway_url}/saveupdatestore`;
    return this.httpClient.post<number>(url, store)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  getAllMaterials(isActive?: number): Observable<any> {
    const active = isActive;
    const url = `${environment.gateway_url}/getallmaterials/${active}`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  updateMaterial(material: Material): Observable<number> {
    const url = `${environment.gateway_url}/saveupdatematerial`;
    return this.httpClient.post<number>(url, material)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  addMaterial(material: Material): Observable<number> {
    const url = `${environment.gateway_url}/saveupdatematerial`;
    return this.httpClient.post<number>(url, material)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error('An error occurred while processing the request.', error.error));
  }

  private handleError1(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      //this.msgService.htmlError('A client-side error occurred. Please try again.');
      this.errorLogService.logErrorNew('Client Side Error', error);
    } else {
      // Server-side error
      if (error.status === 0) {
        //this.msgService.htmlSuccess('The API is currently unreachable. Please try again later.');
        this.errorLogService.logErrorNew('API Not running', error);
      } else {
        //this.msgService.htmlSuccess(`API returned an error: ${error.status} - ${error.message}`);
        this.errorLogService.logErrorNew('API Error', error);
      }
    }

    return throwError('Something went wrong; please try again later.');
  }
  getProductsByCategories(categories: number[]): Observable<any> {
    const url = `${environment.gateway_url}/getproductsbycategories`
    return this.httpClient.post<Product>(url, categories)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }
  //Upload Products File
  UploadProducts_bkp(model: any): Observable<any> {
    const url = `${environment.gateway_url}/uploadproducts`
    return this.httpClient.post<Observable<any>>(url, model, { withCredentials: false });
  }
  UploadProducts(model: any): Observable<any> {
    const url = `${environment.gateway_url}/uploadproducts`;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: false
    };
    // Apply a 10-minute timeout (600000 ms)
    return this.httpClient.post<any>(url, model, httpOptions)
      .pipe(timeout(600000));
  }
  UploadStores(model: any): Observable<any> {
    const url = `${environment.gateway_url}/uploadstores`;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: false
    };
    // Apply a 10-minute timeout (600000 ms)
    return this.httpClient.post<any>(url, model, httpOptions)
      .pipe(timeout(600000));
  }
  getSecretQuestions(): Observable<any> {
    const url = `${environment.gateway_url}/getsecretquestions`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }
  getCriteria(): Observable<any> {
    const url = `${environment.gateway_url}/getcriteria`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }
  getCriteriaAndResponses(): Observable<any> {
    const url = `${environment.gateway_url}/getcriteriaandresponses`;
    return this.httpClient.get(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }
  //Stores List
  GetStoresListReport(storeKeys: { vendorID: number, storeNumber: string }[], isAllStores: boolean): Observable<any> {
    const url = `${environment.gateway_url}/exportstoreslist/${isAllStores}`;

    return this.httpClient.post(url, storeKeys, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map((res: HttpResponse<Blob>) => {
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

}
